import AnalyticsStats from "components/modules/dashboard/AnalyticsStats";
import DepartamentoMaisVendido from "./DepartamentoMaisVendido";
import HorarioPico from "./HorarioPico";
import DepartamentoRentavel from "./DepartamentoRentavel";
import VendedorDestaque from "./VendedorDestaque";
import DashSectionTitle from "./v2/DashSectionTitle";

const WidgetStats = () => {
  return (
    <div id="stats">
      <DashSectionTitle title="KPIs Gerais" subtitle="Indicadores de desempenho atualizados" />

      <div className="mb-4">
        <AnalyticsStats />
      </div>

      <div className="dash-grid dash-grid-4">
        <DepartamentoMaisVendido />
        <HorarioPico />
        <DepartamentoRentavel />
        <VendedorDestaque />
      </div>
    </div>
  );
};

export default WidgetStats;
